import https from './https'

// 添加建筑物
export function addBuilding(data) {
    return https({
        url: '/api/place/add-building',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除建筑物
export function delBuilding(data) {
    return https({
        url: '/api/place/delete-building',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查找建筑物
export function getBuilding(data) {
    return https({
        url: '/api/place/query-building',
        method: 'POST',
        data,
    })
}

// 更新建筑物
export function updateBuilding(data) {
    return https({
        url: '/api/place/update-building',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 添加楼层
export function addFloor(data) {
    return https({
        url: '/api/place/add-floor',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除楼层
export function delFloor(data) {
    return https({
        url: '/api/place/delete-floor',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查找楼层
export function getFloor(data) {
    return https({
        url: '/api/place/query-floor',
        method: 'POST',
        data,
    })
}

// 更新楼层
export function updateFloor(data) {
    return https({
        url: '/api/place/update-floor',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 添加房间
export function addRoom(data) {
    return https({
        url: '/api/place/add-room',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除房间
export function delRoom(data) {
    return https({
        url: '/api/place/delete-room',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查找房间
export function getRoom(data) {
    return https({
        url: '/api/place/query-room',
        // method: 'GET',
        // params: data
        method: 'POST',
        data,
    })
}

// 更新房间
export function updateRoom(data) {
    return https({
        url: '/api/place/update-room',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 添加床
export function addBed(data) {
    return https({
        url: '/api/place/add-bed',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除床
export function delBed(data) {
    return https({
        url: '/api/place/delete-bed',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查找床
export function getBed(data) {
    return https({
        url: '/api/place/query-bed',
        method: 'POST',
        data,
    })
}

// 更新床
export function updateBed(data) {
    return https({
        url: '/api/place/update-bed',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 添加设备
export function addDevice(data) {
    return https({
        url: '/api/device/add-device',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除设备
export function delDevice(data) {
    return https({
        url: '/api/device/delete-device',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询设备
export function getDevice(data) {
    return https({
        // url: '/api/device/query-device',
        url: '/api/user/user-device',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 修改设备
export function updateDevice(data) {
    return https({
        url: '/api/device/update-device',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达类型
export function queryRadarType(data) {
    return https({
        url: '/api/device/query-code',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询历史数据
export function queryHistoryData(data) {
    return https({
        url: '/api/device/his-query',
        method: 'POST',
        data,
        timeout: 5000000,
        isRaw: true
    })
}

// 查询跌倒历史事件
export function queryDownHistory(data) {
    return https({
        url: '/api/tumble/tumbleEventInfo',
        method: 'POST',
        data,
        timeout: 5000000,
        isRaw: true
    })
}


// 查询睡眠报告
export function querySleepData(data) {
    return https({
        url: '/api/his/queryReport',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询50ms数据
export function query50Data(data) {
    return https({
        url: '/api/his/hisTest',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询历史事件
export function queryHisEvent(data) {
    return https({
        url: '/api/his/eventInfo',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 批量导入模板下载
export function downTemplate(data) {
    return https({
        url: '/api/device/file-upload',
        method: 'GET',
        data,
    })
}

// 生命监测雷达配置

// 查询雷达算法参数
export function queryArithmetic(data) {
    return https({
        url: '/api/device/param/query-arithmetic',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 设置雷达算法参数
export function updateArithmetic(data) {
    return https({
        url: '/api/device/param/set-arithmetic',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达信息
export function queryRadarInfo(data) {
    return https({
        url: '/api/device/param/query-radar-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 设置雷达信息
export function setRadarInfo(data) {
    return https({
        url: '/api/device/param/set-radar-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 设置雷达信息
export function updateRadarConfig(data) {
    return https({
        url: '/api/device/param/update-radar-config',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达软件版本号
export function querySoftVersion(data) {
    return https({
        url: '/api/device/param/query-soft-version',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达wifi版本号
export function queryWifiVersion(data) {
    return https({
        url: '/api/device/param/query-wifi-version',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达wifi工作模式
export function queryWifiModel(data) {
    return https({
        url: '/api/device/param/query-wifi-model',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 更改雷达wifi工作模式
export function updateWifiModel(data) {
    return https({
        url: '/api/device/param/update-wifi-model',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达OAT升级进度
export function queryOATProgress(data) {
    return https({
        url: '/api/device/param/query-OAT-progress',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 雷达OAT升级上报信息
export function updateOAT(data) {
    return https({
        url: '/api/device/param/update-ota',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 开启雷达上报信息
export function startRadarReport(data) {
    return https({
        url: '/api/device/param/start-radar-report',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 停止雷达上报信息
export function stopRadarReport(data) {
    return https({
        url: '/api/device/param/stop-radar-report',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 雷达告警设置查询
export function queryAlarm(data) {
    return https({
        url: '/api/device/param/query-waring-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 雷达告警设置
export function setAlarm(data) {
    return https({
        url: '/api/device/param/set-waring-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 跌倒雷达配置
// 查询雷达延迟参数
export function queryDelayInfo(data) {
    return https({
        url: '/api/device/param/query-delay-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 设置雷达延迟参数
export function setDelayInfo(data) {
    return https({
        url: '/api/device/param/set-delay-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查询雷达边界参数
export function queryBoundaryInfo(data) {
    return https({
        url: '/api/device/param/query-boundary-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 设置雷达边界参数
export function setBoundaryInfo(data) {
    return https({
        url: '/api/device/param/set-boundary-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 推送报告
export function pushReport(data) {
    return https({
        url: '/api/his/pushSleepInfo',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 下载报告
export function downReport(data) {
    return https({
        url: '/api/device/his-report',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 推送日志
export function pushLog(data) {
    return https({
        url: '/api/push-log/list',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 免登陆睡眠报告
export function sleepReport(data) {
    return https({
        url: '/api/third-party/query-report-url',
        method: 'GET',
        params: data,
    })
}

// 滞留接口
export function getRetention(data) {
    return https({
        url: '/api/device/param/query-retention-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

export function setRetention(data) {
    return https({
        url: '/api/device/param/set-retention-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 微动检测值接口
export function getMirco(data) {
    return https({
        url: '/api/device/param/query-mirco-move-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

export function setMirco(data) {
    return https({
        url: '/api/device/param/set-mirco-move-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

export function getCCID(data) {
    return https({
        url: '/api/device/param/query-ccid-info',
        method: 'POST',
        data,
        isRaw: true
    })
}

export function getNoMatch(data) {
    return https({
        url: '/api/device/query-unmatch-device',
        method: 'POST',
        data,
        isRaw: true
    })
}


// WEBPACK FOOTER //
// ./src/api/device.js